module.exports = __webpack_public_path__ + "img/IGNIS-GL-BLANCO-POP.45cf9f7b.png";